export const MAX_RECOMMEND_REASON_LENGTH = 200;
